import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const RepeatIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2 10.8V9.00001H7V11.6C7 12.2 6.6 12.6 6 12.6C5.4 12.6 5 12.2 5 11.6V9.00001C5 7.90001 5.9 7.00001 7 7.00001H13H13.1V5.20001C13.1 4.70001 13.7 4.50001 14 4.80001L16.9 7.70001C17.1 7.90001 17.1 8.20001 16.9 8.40001L14.1 11.2C13.7 11.5 13.2 11.2 13.2 10.8ZM17 12.4C17 11.8 17.4 11.4 18 11.4C18.6 11.4 19 11.9 19 12.4V15C19 16.1 18.1 17 17 17H10.8V18.7C10.8 19.2 10.2 19.4 9.90001 19.1L7.10001 16.3C6.90001 16.1 6.90001 15.8 7.10001 15.6L9.90001 12.8C10.3 12.5 10.8 12.8 10.8 13.2V15H17V12.4Z"
      />
    </Icon>
  );
};
